import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { RegionModel } from 'src/app/models/common/region';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BackendListModel } from 'src/app/models/common/list.model';
import { Statemodel } from 'src/app/models/common/statemodel';
import { CountryModel } from 'src/app/models/common/countrymodel';
import { Citymodel } from 'src/app/models/common/citymodel';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GeoApiService {
  base_url = ApiRoutes.Geo;
  API_URL = `${environment.baseApiUrl}/api/geo/state/`;


  constructor(private http: HttpClient) { }
  getAllCountries(): Observable<BackendListModel<CountryModel>> {
    let url = `${this.base_url}country/`;
    return this.http.get<BackendListModel<CountryModel>>(url);
  }

  getCountryById(id): Observable<CountryModel> {
    let url = `${this.base_url}country/${id}/`;
    return this.http.get<CountryModel>(url);
  }
  // getAllStatesByCountryID(): Observable<BackendListModel<Statemodel>> {
  //   let url = `${this.base_url}state/`;
  //   return this.http.get<BackendListModel<Statemodel>>(url);
  // }
  getAllStatesByCountryID(id: any): Observable<BackendListModel<Statemodel>> {
    // let url = `${this.base_url}state/`;
    let url = `${this.base_url}state/?country=${id}`;
    return this.http.get<BackendListModel<Statemodel>>(url);
  }
  // public getAllStatesByCountryID(): Observable<any> {
  //   return this.http.get(' https://arconcore.sreemenon.in/api/geo/state/').pipe(map(res => res));
  // }

  getAllCities(): Observable<BackendListModel<Citymodel>> {
    let url = `${this.base_url}`;
    return this.http.get<BackendListModel<Citymodel>>(url);
  }

  // GET Regions
  getRegion(page_size = '', page = '', search = '', order = ''): Observable<BackendListModel<RegionModel>> {
    let url = `${this.base_url}region/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('name', String(search));
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<RegionModel>>(String(urlObj));
  }

  // GET Region by Id
  getRegionById(regionId: string): Observable<RegionModel> {
    let url = `${this.base_url}region/${regionId}/`;
    return this.http.get<RegionModel>(url);
  }

  // POST Region
  postRegion(data: RegionModel) {
    let url = `${this.base_url}region/`;
    return this.http.post<RegionModel>(url, data);
  }

  // PUT Region
  updateRegion(regionId: string, data: RegionModel) {
    let url = `${this.base_url}region/${regionId}/`;
    return this.http.put(url, data);
  }

  getCountriesMappedInRegion(page_size = 300, page = 1): Observable<BackendListModel<CountryModel>> {
    let url = `${this.base_url}region_country/`;
    let urlObj = new URL(url);
    // urlObj.searchParams.append('name', String(search));
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    return this.http.get<BackendListModel<CountryModel>>(String(urlObj));
  }
}
